<template>
  <div class="backStack-wrap">
    <div class="backStack-side-wrap">
      <SideMenu
        :sideOpen="sideOpen"
        @sideMenuClick="handlerSideClick"></SideMenu>
    </div>
    <div class="backStack-body-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import SideMenu from './components/sideMenu.vue'
import mixinsBackStack from '@/mixins/backStack'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
    }
  },
  components: {
    SideMenu
  },
  methods: {
    handlerSideClick(params) {
      const { name, meta } = params
      this.metaTitle = meta
      this.$router.push({ name })
    }
  }
}
</script>
